import {
  Box,
  Center,
  Heading,
  Text,
} from "@chakra-ui/react";
import LineSection from "../lineSection";
import Lang from "../../Lang";

export default function HeroHome() {
  return (
    <>
      <LineSection />
      <Box
        bgImage={"img/blue-triangle-shapes-polygonal-geometric-mosaic-grid-abstract-waves-background-generative-ai.webp"}
        backgroundSize={'cover'}
        backgroundPosition={'top'}
        color={"white"}
      >
        <Box className="opacityTop">
          <Heading
            as="h1"
            align={"center"}
            fontSize={{ base: "4em", md: "5em", lg: "6em", xl: "8em" }}
            pt={20}
            pb={{ base: "59vh", md: "72vh", xl: "65vh" }}
            className="barlow-black"
          >
            <Lang text="HOW TO APPLY" />
          </Heading>
        </Box>

        <Box className="opacityBottom">
          <Center>
            <Box
              w={{ base: "xl", md: "4xl", xl: "8xl" }}
            >
              <Text
                pb={20}
                px={{ base: 4, md: 6 }}
                fontSize={{ base: "1.5em", md: "3em", xl: "3em" }}
              >
                <Lang text="Let us know what your dream is and what current difficulties you are facing to achieve it." />
              </Text>
            </Box>
          </Center>
        </Box>
      </Box>
    </>
  );
}